module.exports = __webpack_public_path__ + "img/banner2.8ad30259.jpg";